var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetchRecords from './fetchRecords';
import getRecords from './getRecords';
import removeRecordsFromLocalState from './removeRecordsFromLocalState';
import getArrayOverlap from '../arrayOperations/getArrayOverlap';
export default function refreshSpecifiedRecordsIfExist(entity, idsToRefresh) {
    return __awaiter(this, void 0, void 0, function* () {
        const existingIds = getRecords(entity).map(r => r.id);
        const existingIdsToRefresh = getArrayOverlap(idsToRefresh, existingIds);
        // @ts-ignore
        const filter_condition = { predicate: 'containedIn', field: 'id', value: existingIdsToRefresh };
        const fetchParams = {
            payload: {
                api_version: 1,
                filter_conditions: [filter_condition]
            },
            onceFetchedApplyAsPartialRefresh: true
        };
        const fetchedRecords = (yield fetchRecords(entity, fetchParams)).data || [];
        if (!fetchedRecords)
            removeRecordsFromLocalState(entity, idsToRefresh);
        return fetchedRecords;
    });
}
